<template>
  <div class="leaceAppliDetails">
    <div class="page_header">
      <div class="mwow-detail-header">
        <div class="left">
          <div class="back-btn" @click="$router.go(-1)">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="mid">
          <p>
            <span v-if="Number($route.query.id) === 0">添加员工</span>
            <span v-else-if="$route.query.org_id">关联员工</span>
            <span v-else>编辑员工</span>
          </p>
        </div>
      </div>
    </div>
    <div class="basic-info">
      <p class="title">
        基本信息
        <span
          v-show="$route.query.org_id || searchInfo.directly_under === 2"
          class="mwow-tag warning"
          >关联员工的基本信息不可编辑</span
        >
      </p>
      <el-form
        size="mini"
        ref="formployee"
        :model="searchInfo"
        label-width="90px"
        :rules="rules"
        inline-message
      >
        <el-form-item label="用户头像：">
          <div
            v-if="
              !!Number($route.query.org_id) || searchInfo.directly_under === 2
            "
          >
            <img
              width="44"
              height="44"
              :src="searchInfo.avatar_url"
              style="border-radius: 50%; border: 1px dashed #e7e8ea"
            />
          </div>
          <div v-else>
            <avatar-cliper
              @change="handleAvatarChange"
              :originUrl="searchInfo.avatar_url"
              :originName="searchInfo.avatar"
            >
              <template v-slot="scope">
                <div
                  v-show="!scope.url"
                  style="width: 44px; height: 44px"
                ></div>
                <img
                  v-show="scope.url"
                  width="44"
                  height="44"
                  :src="scope.url"
                />
              </template>
            </avatar-cliper>
          </div>
        </el-form-item>
        <el-form-item label="员工姓名：" prop="name">
          <div>
            <el-input
              :disabled="
                !!Number($route.query.org_id) || searchInfo.directly_under === 2
              "
              v-model="searchInfo.name"
              maxlength="18"
              placeholder="请输入员工姓名"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <el-input
            v-model="searchInfo.mobile"
            placeholder="请输入手机号码"
            type="tel"
            :maxlength="maxNum"
            :disabled="Number($route.query.id) !== 0"
          >
            <template slot="prepend">
              <div v-if="Number($route.query.id) !== 0">
                + {{ areaCodePhone.code }}
              </div>
              <div v-else>
                <select-region-phone-number
                  @change="areaCode"
                  :areaCode="areaCodePhone.code"
                >
                  <div class="mwow-green curp">
                    <span
                      >{{ "+" + areaCodePhone.code }}
                      <i class="el-icon-arrow-down"></i
                    ></span>
                  </div>
                </select-region-phone-number>
              </div>
            </template>
          </el-input>
          <div class="phototips">
            此手机号作为员工登录音乐窝系统的账号，不支持系统更改，需员工登录APP更改
          </div>
        </el-form-item>
        <el-form-item label="性别：">
          <el-select
            v-model.number="searchInfo.sex"
            clearable
            placeholder="请选择"
            class="drawer_onlychoose"
            :disabled="
              !!Number($route.query.org_id) || searchInfo.directly_under === 2
            "
          >
            <el-option
              v-for="item in sexList"
              :key="item.value"
              :label="item.value"
              :value="Number(item.key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目：">
          <el-select
            v-model="subjectsListdata"
            multiple
            filterable
            remote
            default-first-option
            :remote-method="globalSearch"
            :placeholder="placeholderData"
            @focus="placeholderFocus"
            :disabled="
              !!Number($route.query.org_id) || searchInfo.directly_under === 2
            "
          >
            <el-option
              v-for="item in subjectsList"
              :key="item.subject_id"
              :label="item.subject_title"
              :value="item.subject_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            type="textarea"
            v-model="searchInfo.remark"
            placeholder="请输入"
            class="elinput"
            :disabled="
              !!Number($route.query.org_id) || searchInfo.directly_under === 2
            "
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="function-empower" v-if="userInfo.org_teach_machine === 1">
      <p class="title">功能授权</p>
      <el-form
        size="mini"
        ref="formployee"
        :model="searchInfo"
        label-width="16px"
        :rules="rules"
        inline-message
      >
        <el-form-item label="">
          <!-- <div class="otherauthor">
            <el-checkbox v-model="searchInfo.is_live"
              ><span class="otherauthorchose">APP直播</span
              ><span class="phototips tipsleft"
                >可以在APP发起普通直播、线上课直播等</span
              ></el-checkbox
            >
          </div> -->
          <div class="otherauthor">
            <el-checkbox
              v-model="searchInfo.teach_machine"
              @change="handleTeachMachineChecked"
              ><span class="otherauthorchose">教学机</span
              ><span class="phototips tipsleft"
                >可以登录音乐窝教学端APP</span
              ></el-checkbox
            >
            <div class="book-selector-wrap" v-if="searchInfo.teach_machine">
              <p class="text">
                已授权<span class="mwow-green">{{
                  searchInfo.book_list.length
                }}</span
                >本
              </p>
              <book-selector
                :origin-data="searchInfo.book_list"
                :origin-type="searchInfo.book_auth"
                @change="handleBookSelect"
              >
                <div class="mwow-button success btn">授权教材</div>
              </book-selector>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="function-empower">
      <p class="title">
        固定休息时间
        <span
          v-show="
            !!Number($route.query.org_id) || searchInfo.directly_under === 2
          "
          class="mwow-tag warning"
          >关联员工的固定休息时间不可编辑</span
        >
      </p>
      <div class="week-day">
        <div
          v-for="item in weekArr"
          :key="item.id"
          @click="
            () => {
              if (
                !!!Number($route.query.org_id) ||
                searchInfo.directly_under === 2
              ) {
                item.checkDay = !item.checkDay;
              }
            }
          "
          class="mwow-button week-in"
          :class="{
            'check-day': item.checkDay,
            disable:
              !!Number($route.query.org_id) || searchInfo.directly_under === 2,
          }"
        >
          {{ item.day }}
        </div>
      </div>
    </div>
    <div class="staff-post">
      <p class="title">
        员工岗位
        <span
          >开启对应岗位, 可在对应岗位筛选中显示员工姓名,
          当前状态开关不受离职状态影响</span
        >
      </p>
      <el-form
        size="mini"
        ref="formployee"
        :model="searchInfo"
        label-width="90px"
        :rules="rules"
        inline-message
      >
        <el-form-item label="课程顾问：">
          <el-switch
            v-model="searchInfo.teachTeacher"
            class="captcha"
            @change="handleChangeSwitch('teachTeacher')"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="教务老师：">
          <el-switch
            v-model="searchInfo.eduTeacher"
            @change="handleChangeSwitch('eduTeacher')"
            class="captcha"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="授课老师：">
          <el-switch
            v-model="searchInfo.is_teach"
            class="captcha"
            @change="handleChangeSwitch('is_teach')"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="校长：">
          <el-switch
            v-model="searchInfo.principal"
            class="captcha"
            @change="handleChangeSwitch('principal')"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="市场顾问：">
          <el-switch
            v-model="searchInfo.market"
            class="captcha"
            @change="handleChangeSwitch('market')"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="employee-nature"
      v-if="searchInfo.is_teach || searchInfo.market"
    >
      <p class="title">
        员工性质
        <span>
          <el-popover
            placement="top"
            width="230"
            popper-class="followuppopover"
            trigger="hover"
          >
            <div class="tipck">
              员工的兼职性质，仅开放授课老师和市场顾
              问岗位，其它岗位不开放兼职性质，仅有 全职性质
            </div>
            <div
              style="display: inline-block"
              class="question"
              slot="reference"
            >
              <div>?</div>
            </div>
          </el-popover>
        </span>
      </p>

      <div class="nature">
        <div
          class="mwow-button nature_type"
          :class="{ active: searchInfo.full_time === 1 }"
          @click="searchInfo.full_time = 1"
        >
          全职
        </div>
        <div
          class="mwow-button nature_type"
          :class="{ active: searchInfo.full_time === 2 }"
          @click="searchInfo.full_time = 2"
        >
          兼职
        </div>
      </div>
    </div>
    <div class="employee-nature" v-else>
      <p class="title">
        员工性质
        <span>
          <el-popover
            placement="top"
            width="230"
            popper-class="followuppopover"
            trigger="hover"
          >
            <div class="tipck">
              员工的兼职性质，仅开放授课老师和市场顾
              问岗位，其它岗位不开放兼职性质，仅有 全职性质
            </div>
            <div
              style="display: inline-block"
              class="question"
              slot="reference"
            >
              <div>?</div>
            </div>
          </el-popover>
        </span>
      </p>

      <div class="nature">
        <div
          class="mwow-button nature_type"
          :class="{ active: searchInfo.full_time === 1 }"
          @click="searchInfo.full_time = 1"
        >
          全职
        </div>
      </div>
    </div>
    <div class="page_content">
      <div class="fromtips">
        <p class="title">身份权限</p>
        <span>
          选择授权身份，将显示对应的权限。（身份不满足？去<span
            class="phototips"
            @click="clickphototips"
            >添加身份</span
          >）
        </span>
      </div>
      <el-form
        size="mini"
        ref="formployee"
        :model="searchInfo"
        label-width="90px"
        :rules="rules"
        inline-message
      >
        <el-form-item label="现有身份：" class="rolebody">
          <div class="idCard">
            <div
              class="idSmCard"
              v-for="(item, index) in roleslistData"
              :key="index"
              :class="{ current: item.choosecurrent == true }"
              @click="clickChoosebox(item)"
            >
              <div class="idSmCardName">
                <span>
                  <img
                    :src="
                      !!item.choosecurrent
                        ? !!item.system
                          ? 'https://wowsite.musicwow.com/teaching_system_frontend/images/store/systemIcon.png'
                          : 'https://wowsite.musicwow.com/teaching_system_frontend/images/store/customIcon.png'
                        : !!item.system
                        ? 'https://wowsite.musicwow.com/teaching_system_frontend/images/store/systemIconCu.png'
                        : 'https://wowsite.musicwow.com/teaching_system_frontend/images/store/customIconCu.png'
                    "
                    alt=""
                  />
                </span>
                {{ item.role_name }}
              </div>
              <div class="idSmCarddetails">
                {{ item.describe }}
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="功能权限：" v-show="role_ids.length > 0">
          <div class="idCardDetails">
            <div class="idCardDetailsCenter">
              <el-tree
                :data="roleDataList"
                show-checkbox
                :props="defaultProps"
                :default-checked-keys="checkedKeys"
                node-key="menu_id"
                default-expand-all
                ref="menuTree"
              >
              </el-tree>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="数据权限：" v-show="role_ids.length > 0">
          <div class="idCardDetails">
            <div class="idCardDetails" style="border: none; padding: 0">
              <div class="idCardDetailsHead">
                数据权限
                <span class="yellow">决定员工可以查看到多少数据或内容</span>
              </div>
              <dataAuthority
                authorityType="system"
                :authorityData="authorityList"
                @optionChoose="optionChooseData"
              ></dataAuthority>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="page_bottom">
        <div class="mwow-button-filled mini" @click="goBack">取消</div>
        <div class="mwow-button-filled mini success" @click="postData">
          保存
        </div>
      </div>
      <div class="page_bottom_right"></div>
      <div class="bottom_block"></div>
    </div>
  </div>
</template>
<script>
import {
  staffDetail,
  relationMenu,
  roleslist,
  modifyInfo,
  staffcreate,
  staffInfoData,
  modifyInfoData,
  createInfoData,
  rolesDataAuthority,
  defaultImgApi,
} from "@/api/staffData";
import avatarCliper from "@/components/avatarCliper.vue";
import { bookSelectListApi } from "@/api/book";
import { addsex, addStudentHeader } from "@/api/studentManage";
import { autoSearchData, getSeleSubjectsList } from "@/api/globalSearch";
import { RouterModule } from "@/store/module/router";
import { UserModule } from "@/store/module/user";
import { Component, Vue } from "vue-property-decorator";
import dataAuthority from "../identitySettings/dataAuthority.vue";
import bookSelector from "./bookSelector/index.vue";
import { phonePass } from "@/utils/rules";
import selectRegionPhoneNumber from "@/components/selectRegionPhoneNumber.vue";
import { PageModule } from "@/store/module/page";
export default {
  components: {
    avatarCliper,
    dataAuthority,
    bookSelector,
    selectRegionPhoneNumber,
  },
  data() {
    return {
      weekArr: [
        {
          day: "星期一",
          id: 1,
          checkDay: false,
        },
        {
          day: "星期二",
          id: 2,
          checkDay: false,
        },
        {
          day: "星期三",
          id: 3,
          checkDay: false,
        },
        {
          day: "星期四",
          id: 4,
          checkDay: false,
        },
        {
          day: "星期五",
          id: 5,
          checkDay: false,
        },
        {
          day: "星期六",
          id: 6,
          checkDay: false,
        },
        {
          day: "星期日",
          id: 0,
          checkDay: false,
        },
      ],
      maxNum: 11,
      areaCodePhone: {
        checked: true,
        code: "86",
        code_id: 1,
        en_name: "China",
        name: "中国大陆",
      },
      idCardIndex: true,
      searchInfo: {
        is_live: 0,
        teach_machine: 0,
        subjectsname: [],
        avatar: "",
        avatar_url: "",
        book_auth: 1,
        book_list: [],
        phoneNumber: 0,
        is_teach: false,
        eduTeacher: false,
        teachTeacher: false,
        principal: false,
        market: false,
        org_id: 0,
        directly_under: 0,
        full_time: 1,
      },
      sexList: [],
      options: [],
      subjectsList: [],
      subjectsListdata: [],
      role_ids: [],
      roleDataList: [],
      checkedKeys: [],
      roleslistData: [],
      placeholderData: "请选择科目",
      defaultProps: {
        children: "children",
        label: "name",
      }, //定义选中盒子的字段
      rules: {
        name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
        mobile: [{ required: true, validator: phonePass, trigger: "blur" }],
      },
      imageUrl: "",
      optionChooseDatas: [],
      authorityList: [],
    };
  },
  computed: {
    userInfo() {
      return UserModule.userInfo;
    },
  },
  created() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    if (_t.id != 0) {
      _t.staffDetailData(
        {
          staff_id: _t.id,
        },
        () => {
          _t.postRolesDataAuthority();
          _t.relationMenuData();
          _t.getroleslist();
          _t.globalSearch();
        }
      );
    } else {
      _t.globalSearch();
      defaultImgApi().then((res) => {
        if (res.error_code === 0) {
          _t.searchInfo.source_avatar_url = res.data.avatar_url;
          _t.searchInfo.avatar = res.data.avatar;
        }
      });
    }
    _t.getFormList(addsex, "sexList");
    if (_t.id == 0) {
      _t.getHead();
      _t.getroleslist();
    }
  },
  // handleTeacherRest(val:any) {
  //   this.weekArr.map((it:any) => {
  //     if (it.id === val.id) {
  //       it.checkDay = !it.checkDay;
  //     }
  //   })
  // }
  methods: {
    handleChangeSwitch(val) {
      if (val === "teachTeacher" && this.searchInfo.teachTeacher === false) {
        this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 课程顾问", {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        })
          .then(() => {
            this.searchInfo.teachTeacher = false;
          })
          .catch(() => {
            this.searchInfo.teachTeacher = true;
          });
      } else if (val === "eduTeacher" && this.searchInfo.eduTeacher === false) {
        this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 教务老师", {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        })
          .then(() => {
            this.searchInfo.eduTeacher = false;
          })
          .catch(() => {
            this.searchInfo.eduTeacher = true;
          });
      } else if (val === "is_teach" && this.searchInfo.is_teach === false) {
        this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 授课老师", {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        })
          .then(() => {
            this.searchInfo.is_teach = false;
            if (!this.searchInfo.market && !this.searchInfo.is_teach) {
              this.searchInfo.full_time = 1;
            }
          })
          .catch(() => {
            this.searchInfo.is_teach = true;
          });
      } else if (val === "principal" && this.searchInfo.principal === false) {
        this.$confirm("此操作不能撤销。确定要关闭吗？", "关闭 - 校长", {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        })
          .then(() => {
            this.searchInfo.principal = false;
          })
          .catch(() => {
            this.searchInfo.principal = true;
          });
      } else if (val === "market" && this.searchInfo.market === false) {
        this.$confirm(
          "关闭市场顾问岗位后，该员工将自动移除对应的数据权限，此操作不能撤销。确定要关闭吗？",
          "关闭 - 市场顾问",
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            this.searchInfo.market = false;
            if (!this.searchInfo.market && !this.searchInfo.is_teach) {
              this.searchInfo.full_time = 1;
            }
          })
          .catch(() => {
            this.searchInfo.market = true;
          });
      }
    },
    optionChooseData(e) {
      this.optionChooseDatas = e;
    },
    changeIsNeedCaptcha(e) {
      const _t = this;
      if (e == true) {
        _t.$confirm(`此操作不能撤销。确定要关闭吗？`, `关闭 - 老师授课`, {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        })
          .then(() => {
            _t.searchInfo.is_live = 0;
            _t.searchInfo.teach_machine = 0;
            _t.searchInfo.is_teach = false;
          })
          .catch(() => {});
      } else {
        _t.searchInfo.is_teach = true;
      }
    },
    // 创建员工时，选中教学机，自动设置为授权全部
    handleTeachMachineChecked(e) {
      if (e && this.searchInfo.book_list.length === 0) {
        bookSelectListApi({
          page: 1,
          page_size: 1000,
        }).then((res) => {
          this.searchInfo.book_list = res.data.list;
          this.searchInfo.book_auth = 1;
        });
      }
    },
    // 授权教材
    handleBookSelect(data) {
      this.searchInfo.book_auth = data.type;
      this.searchInfo.book_list = data.list;
    },
    // 头像弹窗返回
    handleAvatarChange(key) {
      this.searchInfo.avatar = key;
    },
    //获取头像
    getHead() {
      addStudentHeader().then((res) => {
        const _t = this;
        if (res.error_code == 0) {
          _t.imageUrl =
            res.data.list[Math.floor(Math.random() * res.data.list.length)];
          _t.searchInfo.avatar_url = _t.imageUrl.avatar_url;
          _t.searchInfo.avatar = _t.imageUrl.avatar;
        }
      });
    },
    setCover(res) {
      const _t = this;
      _t.searchInfo.avatar = res.data.object;
    },
    getroleslist() {
      const _t = this;
      roleslist().then((res) => {
        if (res.error_code == 0) {
          const allroleList = [];
          if (res.data.system != null) {
            res.data.system.map((a) => {
              a.system = true;
            });
          }
          allroleList.push(...res.data.system);
          allroleList.push(...res.data.custom);
          allroleList.map((a) => {
            a.choosecurrent = false;
            _t.role_ids.map((role_ids) => {
              if (role_ids == a.role_id) {
                a.choosecurrent = true;
              }
            });
          });
          _t.roleslistData = allroleList;
        }
      });
    },
    clickChoosebox(e) {
      const _t = this;
      if (_t.role_ids.indexOf(e.role_id) == -1) {
        _t.role_ids.push(e.role_id);
        e.choosecurrent = true;
      } else {
        _t.role_ids.splice(_t.role_ids.indexOf(e.role_id), 1);
        e.choosecurrent = false;
      }
      if (_t.role_ids.length > 0) {
        _t.relationMenuData();
        _t.postRolesDataAuthority();
      } else {
        _t.checkedKeys.length = 0;
      }
    },
    clickphototips() {
      const _t = this;
      _t.$confirm(
        `你将打开角色身份添加页面，当前页面填写的数据将丢失，确定继续打开？`,
        `打开 - 添加身份`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          _t.$router.push({ name: "employeeManage", query: { type: "add" } });
        })
        .catch(() => {});
    },
    //获取表单列表
    getFormList(cb, type) {
      const _t = this;
      cb().then((res) => {
        if (res.error_code == 0) {
          _t[type] = res.data.list;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    async globalSearch(queryString) {
      const params = {
        page: 1,
        page_size: 500,
        status: 1,
      };
      if (queryString) {
        params.title = queryString;
      }
      getSeleSubjectsList(params).then((res) => {
        this.subjectsList = res.data.list;
      });
    },
    staffDetailData(params, cb) {
      const _t = this;
      // 如果query中带有机构id，则表示正在关联新员工
      const oid = _t.$route.query.org_id;
      if (oid) {
        params.org_id = oid;
      }
      staffDetail(params).then((res) => {
        if (res.error_code == 0) {
          res.data.is_teach = res.data.is_teach == 1 ? true : false;
          res.data.is_live = res.data.is_live == 1 ? true : false;
          res.data.teach_machine = res.data.teach_machine == 1 ? true : false;
          res.data.teach_machine = res.data.teach_machine == 1 ? true : false;
          if (res.data.jobs) {
            res.data.jobs.map((item) => {
              if (item.job_id === 1) {
                res.data.is_teach = true;
              } else if (item.job_id === 2) {
                res.data.eduTeacher = true;
              } else if (item.job_id == 3) {
                res.data.teachTeacher = true;
              } else if (item.job_id == 4) {
                res.data.market = true;
              } else if (item.job_id == 5) {
                res.data.principal = true;
              }
            });
          }
          if (res.data.resting_time) {
            res.data.resting_time.map((item) => {
              this.weekArr.map((it) => {
                if (item === it.id) {
                  it.checkDay = true;
                }
              });
            });
          }
          res.data.avatar = res.data.avatar === "" ? "" : res.data.avatar;
          res.data.source_avatar_url =
            res.data.avatar_url === "" ? "" : res.data.avatar_url;
          const newarry = res.data.subjects;
          newarry.map((a, b) => {
            newarry[b]["subject_id"] = newarry[b]["key"];
            newarry[b]["subject_title"] = newarry[b]["value"];
            _t.subjectsListdata[b] = newarry[b]["key"];
            delete newarry[b]["key"];
            delete newarry[b]["value"];
          });
          if (_t.subjectsListdata.length > 0) {
            _t.placeholderData = "";
          }
          _t.subjectsList = newarry;
          if (res.data.area_code) {
            PageModule.SET_PAGE_INFO({
              name: "areaCodePhoneNumber",
              key: "area_code",
              value: res.data.area_code,
            });
          }
          _t.areaCodePhone.code = res.data.area_code;
          _t.searchInfo = res.data;
          _t.role_ids = res.data.roles;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
        if (cb) {
          cb();
        }
      });
    },
    placeholderFocus() {
      const _t = this;
      if (_t.subjectsListdata.length == 0) {
        _t.placeholderData = "请选择科目";
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    relationMenuData() {
      const _t = this;
      const role_ids = _t.role_ids.join(",");
      relationMenu({ role_ids: role_ids }).then((res) => {
        if (res.error_code == 0) {
          _t.checkedKeys.length = 0;
          _t.roleDataList = res.data.list;
          _t.itemGetid(res.data.list);
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    postRolesDataAuthority() {
      const _t = this;
      rolesDataAuthority({ roles: _t.role_ids }).then((res) => {
        if (res.error_code == 0) {
          _t.authorityList = res.data.list;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    itemGetid(itemData) {
      const _t = this;
      itemData.map((item) => {
        if (item.is_select) {
          if (item.children == null) {
            _t.checkedKeys.push(item.menu_id);
          }
        }
        if (item.children != null) {
          _t.itemGetid(item.children);
        }
        item.disabled = true;
      });
    },
    postData() {
      const _t = this;
      const data = {
        name: _t.searchInfo.name,
        mobile: _t.searchInfo.mobile,
        teach_machine: _t.searchInfo.teach_machine ? 1 : 2,
        roles: [],
        remark: _t.searchInfo.remark,
        book_auth: _t.searchInfo.book_auth,
        book_ids: [],
        area_code: _t.areaCodePhone.code,
        full_time: _t.searchInfo.full_time,
      };
      const arr = [];
      if (_t.searchInfo.is_teach) {
        arr.push(1);
      }
      if (_t.searchInfo.eduTeacher) {
        arr.push(2);
      }
      if (_t.searchInfo.teachTeacher) {
        arr.push(3);
      }
      if (_t.searchInfo.principal) {
        arr.push(5);
      }
      if (_t.searchInfo.market) {
        arr.push(4);
      }
      data.job_ids = arr;
      data.avatar = _t.searchInfo.avatar;
      data.sex = Number(_t.searchInfo.sex);
      data.subjects = _t.subjectsListdata;

      if (_t.searchInfo.book_auth === 1) {
        data.book_ids = [];
      } else {
        data.book_ids = _t.searchInfo.book_list.map((item) => {
          return item.book_id;
        });
      }
      if (!_t.searchInfo.name) {
        _t.$message({
          type: "error",
          message: "请输入员工姓名!",
        });
        return;
      }
      if (!_t.searchInfo.mobile) {
        _t.$message({
          type: "error",
          message: "请输入手机号!",
        });
        return;
      }
      if (_t.role_ids.length == 0) {
        _t.$message({
          type: "error",
          message: "请选择角色身份!",
        });
        return;
      } else {
        data.roles = _t.role_ids;
      }
      const newWeekArr = [];
      // 固定休息数组
      this.weekArr.map((it) => {
        if (it.checkDay) {
          newWeekArr.push(it.id);
        }
      });
      if (newWeekArr.length > 0) {
        data.resting_time = newWeekArr;
      }
      // return;
      _t.$refs["formployee"].validate((valid) => {
        if (valid) {
          const id = Number(_t.$route.query.id);
          const oid = Number(_t.$route.query.org_id);
          // 新建
          if (id === 0) {
            const cdata = data;
            staffcreate(cdata).then((res) => {
              if (res.error_code == 0) {
                // 成功，邀请加入
                _t.$alert(
                  `${data.name}员工资料已添加完成，请复制邀请链接发给员工授权加入。`,
                  `邀请加入-${data.name}`,
                  {
                    confirmButtonText: "复制邀请链接",
                    callback: () => {
                      const link = res.data.activate_url;
                      navigator.clipboard.writeText(link).then(() => {
                        _t.$message({
                          type: "success",
                          message: "复制成功",
                        });
                      });
                      _t.goBack();
                    },
                  }
                );
              } else {
                _t.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          } else {
            if (oid) {
              // 正在为门店关联新员工
              const cdata = data;
              cdata.staff_id = id;
              staffcreate(cdata).then((res) => {
                if (res.error_code == 0) {
                  _t.$message({
                    type: "success",
                    message: `关联成功!`,
                  });
                  _t.goBack();
                } else {
                  _t.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              });
            } else {
              // 无oid代表直属员工编辑
              const mdata = {
                ...data,
                staff_id: id,
              };
              modifyInfo(mdata).then((res) => {
                if (res.error_code == 0) {
                  _t.$message({
                    type: "success",
                    message: "修改成功!",
                  });
                  _t.staffDetailData(
                    {
                      staff_id: _t.id,
                    },
                    () => {
                      _t.getFormList(addsex, "sexList");
                      _t.getroleslist();
                      _t.relationMenuData();
                      _t.postRolesDataAuthority();
                    }
                  );
                  _t.goBack();
                  if (_t.id === UserModule.userInfo.staff_id) {
                    // 修改自己后重新获取一遍个人信息和菜单
                    RouterModule.SetAsyncRouter();
                  }
                } else {
                  _t.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    areaCode(data) {
      PageModule.SET_PAGE_INFO({
        name: "areaCodePhoneNumber",
        key: "area_code",
        value: data[0].code,
      });
      if (data) {
        this.areaCodePhone = data[0];
        if (
          data[0].code !== "86" &&
          data[0].code !== "852" &&
          data[0].code !== "853" &&
          data[0].code !== "886"
        ) {
          this.maxNum = 16;
          return;
        } else if (data[0].code === "852" || data[0].code === "853") {
          this.maxNum = 8;
          return;
        } else if (data[0].code === "886") {
          this.maxNum = 10;
          return;
        } else {
          this.maxNum = 11;
          return;
        }
      }
    },
    beforeDestroy() {
      PageModule.SET_PAGE_INFO({
        name: "areaCodePhoneNumber",
        key: "area_code",
        value: "",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.leaceAppliDetails {
  .basic-info {
    background-color: #fff;
    padding: 13px;
    margin-bottom: 13px;
    min-height: 88%;
    .title {
      font-size: 18px;
      padding: 10px 0 13px 10px;
    }
    .el-form-item {
      margin-bottom: 13px !important;
    }
    /deep/ .el-input {
      width: 260px !important;
    }
    .el-textarea {
      width: 544px !important;
      /deep/ textarea {
        min-height: 68px !important;
      }
    }
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      .el-range__icon,
      .el-range-separator {
        line-height: 24px;
      }
    }
    /deep/ .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9 !important;
      border-radius: 50%;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 44px;
      height: 44px;
      line-height: 44px;
      text-align: center;
    }
    .avatar {
      width: 44px;
      height: 44px;
      display: block;
    }
    .leaveTime {
      padding: 12px 20px 20px 20px;
      background: #f2f6fa;
      max-width: 694px;
      border-radius: 4px;
      .leaveTimeBox {
        color: #ffb940;
        font-size: 12px;
        margin-bottom: 12px;
      }
      .leaveTimeCenterBox {
        display: flex;
        width: 100%;
        justify-content: space-between;
        .leaveTimeSmCenter {
          border-radius: 4px;
          padding: 12px;
          min-width: 194px;
          background: #fff;
          color: #5c5d5e;
          font-size: 12px;
          line-height: 20px;
          .leaveTimeFw {
            font-weight: bold;
          }
          .leaveTimeBtn {
            margin-top: 8px;
            padding-top: 8px;
            border-top: 1px solid #e3e4e5;
          }
        }
      }
    }
    .phototips {
      color: #07d1aa;
      font-size: 10px;
      cursor: pointer;
    }
    .tipsleft {
      margin-left: 28px;
    }
    .idCard {
      display: flex;
      flex-wrap: wrap;
      .idSmCard.current {
        border: 1px solid #07d1aa;
        position: relative;
        &::after {
          content: "";
          width: 10px;
          height: 5px;
          border: 1px solid white;
          border-top: transparent;
          border-right: transparent;
          text-align: center;
          display: block;
          position: absolute;
          transform: rotate(-45deg);
          border-radius: 0px;
          background: none;
          right: 1px;
          top: 2px;
        }
        &::before {
          content: "";
          width: 15px;
          height: 15px;
          position: absolute;
          right: 0;
          top: 0;
          background: #07d1aa;
        }
      }
      .idSmCard {
        padding: 12px 19px;
        min-height: 70px;
        width: 130px;
        margin-top: 15px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        line-height: normal;
        margin-right: 20px;
        .idSmCardName {
          display: flex;
          align-items: center;
          margin-bottom: 9px;
          span {
            width: 19px;
            height: 19px;
            opacity: 1;
            background: #d8d8d8;
            border-radius: 4px;
            margin-right: 8px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .idSmCarddetails {
          color: #9e9fa0;
          font-size: 10px;
        }
      }
      // .idSmCard:nth-of-type(3n+2){
      //   margin:0 20px;
      //   margin-top:15px;
      // }
    }
    .idCardDetails {
      padding: 20px;
      width: calc(100% - 40px);
      border: 1px solid #d9dadb;
      border-radius: 4px;
      margin-top: 20px;
      font-size: 12px;
      .idCardDetailsHead {
        font-size: 12px;
        font-weight: bold;
        span {
          color: #07d1aa;
          font-size: 12px;
          margin-left: 20px;
          font-weight: normal;
        }
      }
      .idCardDetailsCenter {
        padding: 0 10px;
        display: flex;
        .idCardDetails {
          padding: 10px 20px;
          width: 96%;
          border: 1px solid #d9dadb;
          border-radius: 4px;
          margin-bottom: 20px;
          font-size: 12px;
          .idCardDetailsTabls {
            display: flex;
            flex-wrap: wrap;
            div {
              padding: 7px 15px;
              font-size: 12px;
              color: #5c5d5e;
              background: #f6fafc;
              margin-right: 10px;
              margin-top: 10px;
            }
          }
          .idCardDetailsHead {
            font-size: 14px;
            font-weight: bold;
            line-height: 28px;
            span {
              color: #07d1aa;
              font-size: 12px;
              margin-left: 20px;
              font-weight: normal;
            }
          }
        }
      }
      .chooseTiele {
        color: #5c5d5e;
      }
      .choose_Details {
        padding: 0 10px;
        .chooseChooseSon {
          padding-left: 25px;
        }
      }
    }
    .color_list {
      display: flex;
      min-height: 29px;
      align-items: center;
      position: relative;
      flex-wrap: wrap;
      .xm_color {
        margin-right: 12px;
        width: 16px;
        cursor: pointer;
        .xm_color_border {
          width: 16px;
          height: 16px;
          border-radius: 2px;
          display: -ms-flexbox;
          display: flex;
          -ms-flex-pack: center;
          justify-content: center;
          -ms-flex-align: center;
          align-items: center;
          .xm_color_inner {
            width: 12px;
            height: 12px;
            border-radius: 2px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-transition: all 1s;
            -o-transition: all 1s;
            transition: all 1s;
            .xm_color_center {
              width: 10px;
              height: 10px;
              border-radius: 2px;
            }
          }
        }
      }
      .set_color_modal {
        position: absolute;
        width: 336px;
        left: -40px;
        top: 30px;
        z-index: 2;
        background: #fff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
        padding: 0 10px;
        padding-bottom: 10px;
        .xm_color {
          margin-top: 10px;
          .xm_color_border {
            width: 22px;
            height: 22px;
            .xm_color_inner {
              width: 18px;
              height: 18px;
              .xm_color_center {
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }
  }
  .function-empower {
    background-color: #fff;
    padding: 13px;
    margin-bottom: 13px;
    min-height: 88%;
    .title {
      font-size: 18px;
      padding: 10px 0 13px 10px;
    }
    .week-day {
      padding-left: 15px;
      .week-in {
        margin-right: 15px;
        &:hover {
          background-color: #07d1aa !important;
          color: #ffffff !important;
          border-color: #07d1aa !important;
        }
        &.disable {
          cursor: not-allowed !important;
        }
      }
      .check-day {
        background-color: #07d1aa !important;
        color: #ffffff !important;
        border-color: #07d1aa !important;
      }
    }
    .otherauthor {
      line-height: 33px;
      .otherauthorchose {
        width: 50px;
        display: inline-block;
      }
    }
    .phototips {
      color: #07d1aa;
      font-size: 10px;
      cursor: pointer;
    }
    .tipsleft {
      margin-left: 28px;
    }
  }
  .staff-post {
    background-color: #fff;
    padding: 13px;
    margin-bottom: 13px;
    min-height: 88%;
    .title {
      font-size: 18px;
      padding: 10px 0 13px 10px;
      span {
        color: #999999;
        font-size: 10px;
        margin-left: 28px;
      }
    }
  }
  .employee-nature {
    background-color: #fff;
    padding: 13px;
    margin-bottom: 13px;
    min-height: 88%;
    .title {
      font-size: 18px;
      padding: 10px 0 13px 10px;
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
      /deep/.el-popover__reference-wrapper {
        .question {
          margin: 0 0 0 4px !important;
          width: 19px;
          height: 17px;
          line-height: 18px;
        }
      }
    }
    .nature {
      padding: 10px 0 13px 20px;
      .nature_type {
        margin-right: 15px;
        height: 40px !important;
        text-align: center;
        line-height: 40px !important;
        width: 60px;
        font-size: 14px !important;
      }
      .active {
        border-color: #07d1aa !important;
        background-color: #07d1aa !important;
        color: #ffffff !important;
      }
    }
  }
  .page_header {
    background: #fff;
    padding: 0 13px;
  }
  .page_header_left {
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: center;
  }
  .el-icon-back {
    font-size: 18px;
    margin-right: 6px;
    align-self: center;
  }
  .el-icon-back:before {
    content: "\e6ea";
  }
  .page_header_left_back {
    font-size: 14px;
    font-weight: 500;
    margin-right: 40px;
    position: relative;
  }
  .page_header_left_back::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #dcdfe6;
  }
  .page_header_content {
    font-size: 13px;
    font-weight: bold;
    color: #5c5d5e;
  }
  .page_header_control {
    display: flex;
    div:nth-of-type(2) {
      margin: 0 10px;
    }
  }
  //中间
  .page_content {
    background: #fff;
    padding: 13px;
    padding-top: 22px;
    min-height: 88%;
    padding-bottom: 0;
    .el-form-item {
      margin-bottom: 13px !important;
    }
    /deep/ .el-input {
      width: 260px !important;
    }
    .el-textarea {
      width: 544px !important;
      /deep/ textarea {
        min-height: 68px !important;
      }
    }
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      .el-range__icon,
      .el-range-separator {
        line-height: 24px;
      }
    }
    /deep/ .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9 !important;
      border-radius: 50%;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 44px;
      height: 44px;
      line-height: 44px;
      text-align: center;
    }
    .avatar {
      width: 44px;
      height: 44px;
      display: block;
    }
    .fromtips {
      color: #9e9fa0;
      font-size: 12px;
      line-height: 33px;
      .title {
        font-size: 18px;
        color: #000;
        display: inline-block;
        margin-right: 28px;
      }
    }
    .leaveTime {
      padding: 12px 20px 20px 20px;
      background: #f2f6fa;
      max-width: 694px;
      border-radius: 4px;
      .leaveTimeBox {
        color: #ffb940;
        font-size: 12px;
        margin-bottom: 12px;
      }
      .leaveTimeCenterBox {
        display: flex;
        width: 100%;
        justify-content: space-between;
        .leaveTimeSmCenter {
          border-radius: 4px;
          padding: 12px;
          min-width: 194px;
          background: #fff;
          color: #5c5d5e;
          font-size: 12px;
          line-height: 20px;
          .leaveTimeFw {
            font-weight: bold;
          }
          .leaveTimeBtn {
            margin-top: 8px;
            padding-top: 8px;
            border-top: 1px solid #e3e4e5;
          }
        }
      }
    }
    .phototips {
      color: #07d1aa;
      font-size: 10px;
      cursor: pointer;
    }
    .otherauthor {
      line-height: 33px;
      .otherauthorchose {
        width: 50px;
        display: inline-block;
      }
    }
    .tipsleft {
      margin-left: 28px;
    }
    .idCard {
      display: flex;
      flex-wrap: wrap;
      .idSmCard.current {
        border: 1px solid #07d1aa;
        position: relative;
        &::after {
          content: "";
          width: 10px;
          height: 5px;
          border: 1px solid white;
          border-top: transparent;
          border-right: transparent;
          text-align: center;
          display: block;
          position: absolute;
          transform: rotate(-45deg);
          border-radius: 0px;
          background: none;
          right: 1px;
          top: 2px;
        }
        &::before {
          content: "";
          width: 15px;
          height: 15px;
          position: absolute;
          right: 0;
          top: 0;
          background: #07d1aa;
        }
      }
      .idSmCard {
        padding: 12px 19px;
        min-height: 70px;
        width: 130px;
        margin-top: 15px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        line-height: normal;
        margin-right: 20px;
        .idSmCardName {
          display: flex;
          align-items: center;
          margin-bottom: 9px;
          span {
            width: 19px;
            height: 19px;
            opacity: 1;
            background: #d8d8d8;
            border-radius: 4px;
            margin-right: 8px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .idSmCarddetails {
          color: #9e9fa0;
          font-size: 10px;
        }
      }
      // .idSmCard:nth-of-type(3n+2){
      //   margin:0 20px;
      //   margin-top:15px;
      // }
    }
    .idCardDetails {
      padding: 20px;
      width: calc(100% - 40px);
      border: 1px solid #d9dadb;
      border-radius: 4px;
      margin-top: 20px;
      font-size: 12px;
      .idCardDetailsHead {
        font-size: 12px;
        font-weight: bold;
        span {
          color: #07d1aa;
          font-size: 12px;
          margin-left: 20px;
          font-weight: normal;
        }
      }
      .idCardDetailsCenter {
        padding: 0 10px;
        display: flex;
        .idCardDetails {
          padding: 10px 20px;
          width: 96%;
          border: 1px solid #d9dadb;
          border-radius: 4px;
          margin-bottom: 20px;
          font-size: 12px;
          .idCardDetailsTabls {
            display: flex;
            flex-wrap: wrap;
            div {
              padding: 7px 15px;
              font-size: 12px;
              color: #5c5d5e;
              background: #f6fafc;
              margin-right: 10px;
              margin-top: 10px;
            }
          }
          .idCardDetailsHead {
            font-size: 14px;
            font-weight: bold;
            line-height: 28px;
            span {
              color: #07d1aa;
              font-size: 12px;
              margin-left: 20px;
              font-weight: normal;
            }
          }
        }
      }
      .chooseTiele {
        color: #5c5d5e;
      }
      .choose_Details {
        padding: 0 10px;
        .chooseChooseSon {
          padding-left: 25px;
        }
      }
    }
    .color_list {
      display: flex;
      min-height: 29px;
      align-items: center;
      position: relative;
      flex-wrap: wrap;
      .xm_color {
        margin-right: 12px;
        width: 16px;
        cursor: pointer;
        .xm_color_border {
          width: 16px;
          height: 16px;
          border-radius: 2px;
          display: -ms-flexbox;
          display: flex;
          -ms-flex-pack: center;
          justify-content: center;
          -ms-flex-align: center;
          align-items: center;
          .xm_color_inner {
            width: 12px;
            height: 12px;
            border-radius: 2px;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-transition: all 1s;
            -o-transition: all 1s;
            transition: all 1s;
            .xm_color_center {
              width: 10px;
              height: 10px;
              border-radius: 2px;
            }
          }
        }
      }
      .set_color_modal {
        position: absolute;
        width: 336px;
        left: -40px;
        top: 30px;
        z-index: 2;
        background: #fff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
        padding: 0 10px;
        padding-bottom: 10px;
        .xm_color {
          margin-top: 10px;
          .xm_color_border {
            width: 22px;
            height: 22px;
            .xm_color_inner {
              width: 18px;
              height: 18px;
              .xm_color_center {
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }
  }
  .page_bottom {
    display: flex;
    position: fixed;
    padding-bottom: 10px;
    background: #fff;
    bottom: 12px;
    padding-top: 10px;
    border-top: 1px solid #e7e8ea;
    z-index: 999;
    width: 100%;
    margin-left: -10px;
    padding-left: 10px;
    .info {
      margin-right: 10px;
    }
    div {
      margin-right: 12px;
    }
  }
  .page_bottom_right {
    position: fixed;
    bottom: 12px;
    right: 0;
    width: 30px;
    height: 46px;
    background-image: linear-gradient(to right, #ffffff 50%, #eef3f6 50%);
    z-index: 999;
  }
  .bottom_block {
    height: 40px;
  }
  .idCardDetails {
    /deep/ .el-checkbox__inner {
      background: #dcdfe6 !important;
      border-color: #dcdfe6 !important;
    }
    /deep/ .el-checkbox__inner::after {
      border-color: #000 !important;
    }
  }
  /deep/ .el-tree-node.is-expanded > .el-tree-node__children {
    display: flex;
    flex-wrap: wrap; // flex横向布局换行显示
  }
  /deep/ .collapse-transition {
    transition: none !important;
  }
  /deep/ .captcha.el-switch.is-disabled {
    opacity: 1;
    .el-switch__core {
      cursor: pointer;
    }
  }
  .elinput {
    font-size: 12px;
  }
  .rolebody {
    /deep/ .el-form-item__label {
      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }
  }
}
.yellow {
  color: #ffb940 !important;
}
.book-selector-wrap {
  .text {
    display: inline-block;
    font-size: 12px;
    color: #5c5d5e;
  }
  .btn {
    margin-left: 41px;
    cursor: pointer;
  }
}
.curp {
  cursor: pointer;
}
</style>
